import {
  APP_INIT,
  ETH_FEE_UPDATED,
  CAT_FEE_UPDATED,
  LATEST_BLOCK_NUMBER_UPDATED,
  RECOMMENDED_GAS_PRICES_UPDATED,
  CAMPAIGNS_FETCH_FAILED,
} from '../actionTypes';

export const getDefaultState = () => ({
  rewardsContractAddress: '',
  catTokenAddress: '',
  catPaymentContractAddress: '',
  ethFee: null,
  catFee: null,
  latestBlockNumber: 0,
  expectedNetwork: '',
  recommendedGasPrices: {},
  abandonCampaignCreationMessage: '',
  abandonRewardsDownloadMessage: '',
  appUrl: '',
  supportedWallets: [],
});

const reducer = (state = getDefaultState(), action) => {
  switch (action.type) {
    case APP_INIT:
      return {
        ...state,
        rewardsContractAddress: action.rewardsContractAddress,
        catTokenAddress: action.catTokenAddress,
        catPaymentContractAddress: action.catPaymentContractAddress,
        expectedNetwork: action.expectedNetwork,
        abandonCampaignCreationMessage: action.abandonCampaignCreationMessage,
        abandonRewardsDownloadMessage: action.abandonRewardsDownloadMessage,
        appUrl: action.appUrl,
        supportedWallets: action.supportedWallets,
      };

    case ETH_FEE_UPDATED:
      return {
        ...state,
        ethFee: action.ethFee,
      };

    case CAT_FEE_UPDATED:
      return {
        ...state,
        catFee: action.catFee,
      };

    case LATEST_BLOCK_NUMBER_UPDATED:
      return {
        ...state,
        latestBlockNumber: action.blockNumber,
      };

    case RECOMMENDED_GAS_PRICES_UPDATED:
      return {
        ...state,
        recommendedGasPrices: action.recommendedGasPrices,
      };

    // If the initial campaign fetching failed, reset to 0 to allow polling to fetch all.
    case CAMPAIGNS_FETCH_FAILED:
      return {
        ...state,
        latestBlockNumber: 0,
      };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/app.js